var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "url(#paint0_linear_145_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14071 9.45975C6.43363 10.9419 7.50525 11.9016 8.8698 11.9016C10.2343 11.9016 11.2881 10.9682 11.5989 9.46303C11.6489 9.23298 11.8882 8.06957 11.9025 7.78693C11.9382 7.07377 11.656 6.39675 11.1131 5.8742C10.5344 5.31879 9.71638 5 8.8698 5C8.02321 5 7.18377 5.32536 6.60151 5.89063C6.0657 6.41318 5.79065 7.0902 5.83709 7.79022C5.85495 8.07614 6.11214 9.32171 6.14071 9.45975ZM7.12304 6.34417C7.56955 5.90707 8.20539 5.65729 8.8698 5.65729C9.53421 5.65729 10.1558 5.90049 10.5987 6.32774C11.0059 6.71883 11.2167 7.22494 11.1881 7.75735C11.1809 7.93811 11.0059 8.82546 10.8952 9.33815C10.7023 10.2584 10.07 11.2443 8.86622 11.2443C7.66243 11.2443 7.01231 10.2189 6.83727 9.33815C6.73011 8.82217 6.55865 7.93482 6.54436 7.75078C6.51221 7.23152 6.71582 6.73197 7.1159 6.34088L7.12304 6.34417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2342 13.4522L8.86915 12.9165L4.52905 13.4456C3.4467 13.6395 2.28934 14.3264 2.13931 15.4339L2 18.1486H15.849L15.6776 15.549C15.6026 14.4743 14.6952 13.6921 13.2342 13.4555V13.4522ZM2.65727 17.488L2.84659 15.4997C2.95018 14.7339 3.86106 14.2311 4.64335 14.0898L8.86915 13.5771L13.1235 14.0996C13.6522 14.1851 14.8881 14.5039 14.9631 15.5851L15.0882 17.488H2.65727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1172 10.7387C14.3566 11.9448 15.2425 12.7237 16.3712 12.7237C17.5 12.7237 18.368 11.9646 18.6252 10.742C18.6645 10.5579 18.8574 9.63773 18.8681 9.40767C18.8967 8.83254 18.6681 8.28041 18.2287 7.85646C17.7536 7.39964 17.0749 7.13672 16.3712 7.13672C15.6675 7.13672 14.9745 7.40621 14.4959 7.87289C14.0601 8.30013 13.8386 8.84569 13.8743 9.41425C13.8886 9.64101 14.0815 10.5612 14.1172 10.742V10.7387ZM15.0138 8.32314C15.3568 7.98792 15.8533 7.79401 16.3677 7.79401C16.882 7.79401 17.3679 7.98134 17.7072 8.30999C18.0108 8.60249 18.168 8.98372 18.1501 9.37809C18.143 9.50955 18.0108 10.1833 17.918 10.6171C17.8465 10.9556 17.5215 12.0664 16.3641 12.0664C15.4318 12.0664 14.9531 11.3204 14.8138 10.6171C14.7281 10.2129 14.5923 9.51613 14.5816 9.37481C14.5566 8.99029 14.7102 8.61563 15.0103 8.32314H15.0138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7133 18.1455H21.9998L21.9605 15.6741C21.8855 14.7834 21.1389 14.1327 19.9387 13.9355L16.4095 13.5444L16.3237 14.1984L19.8315 14.5862C20.2352 14.652 21.1782 14.8952 21.2461 15.7168L21.3461 17.4882H17.7097V18.1455H17.7133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_27",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.6f0fcf66f130c20922b7546cf1c063dc.svg";
export { ForwardRef as ReactComponent };